<template>
    <div>
        <div class="arrow--bottom">
            <div class="d-inline-flex flex-column custom--bubble custom--bubble__scrollbox">
                <div class="text-h5 text-md-h4"> <!-- todo: need to fix scroll window for long quotes on mobile view -->
                    <div id="quoteSteady" v-html="selectedQuote"></div>
                    <div id="quoteTyped" ref="outputDiv" v-html="txtBeingTyped"></div>
                </div>
            </div>
        </div>
        <div v-if="quoteAuthor" class="my-15 quote-author">
            － {{ quoteAuthor }}
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            selectedQuote: {
                type: String,
                required: true,
            },
            quoteAuthor: {
                type: String,
                required: false,
                default: undefined,
            },
        },

        data() {
            return {
                txtBeingTyped: '',
            };
        },

        mounted() {
            this.typeText();
        },

        methods: {
            typeText() {
                let i = 0;
                this.txtBeingTyped = '';
                let txtToType = '';
                if (!!this.selectedQuote) txtToType = this.selectedQuote;
                const timer = setInterval(() => {
                    if (i < txtToType.length) {
                        this.txtBeingTyped += txtToType.charAt(i);// outputDiv.innerHTML += txtToType.charAt(i);
                        i++;
                    } else {
                        clearInterval(timer);
                    }
                }, 20);
            },
        },
    };
</script>
<style lang="scss" scoped>
    $c-blue: #1876d2;
    $c-shadow: darken($c-blue, 8%);
    $c-shadow-light: lighten($c-blue, 18%); // rgba(255,255,255,.2)
    .custom--bubble {
        text-align: left;
        position: relative;
        z-index:1;
        //border-top:1px solid $c-shadow-light;
        //border-left:1px solid $c-shadow-light;
        //border-right:1px solid $c-shadow-light;
        border:3px solid $c-shadow-light;
        border-radius: 2.5em;
        background: $c-blue;
        color: white;
        max-width: 500px;
        margin: 0 auto;

        ////// FANCY BOX SHADOW - (NOTE: Looks broken on Mobile view)
        //transform: rotate(-6deg) skew(-3deg, 5deg) translateX(-15%);
        //box-shadow:
        //    inset 0px 8px 4px $c-shadow-light,
        //    inset 0px 12px 8px $c-shadow-light,
        //    inset 0px 16px 12px $c-shadow-light
        //;
        //filter:
        //    drop-shadow(-1px 1px 0 $c-shadow)
        //    drop-shadow(-2px 1px 0 $c-shadow)
        //    drop-shadow(-3px 1px 0 $c-shadow)
        //    drop-shadow(-4px 1px 0 $c-shadow)
        //
        //    drop-shadow(0px 10px 10px rgba(0,0,0,0.2))
        //;

        // ADDED FOR BOTH MOBILE & DESKTOP TO BE SIMILARLY CONFINED TO SPACE / SIZE UI
        min-width: 300px;
        max-height: 40vh;

        // MOBILE UI
        @media screen and (max-width: 500px) {
            //min-width: 300px;
            //max-height: 40vh;
            //transform: rotate(-3deg) skew(-3deg, 3deg) translateX(-5%);
            max-width: 80vw;
        }
        // INNER TEXTBOX
        ::v-deep &__scrollbox {
            width: 100%;
            height: 100%;
            overflow: auto;
            ///* REMOVE NATIVE BROWSER OVERFLOW SCROLLBAR */
            -webkit-appearance: none;
            -webkit-overflow-scrolling: auto;
            -ms-overflow-style: none; /* IE 11 */
            scrollbar-width: none; /* Firefox 64 */
            scrollbar-height: none; /* Firefox 64 */
            &::-webkit-scrollbar {
                display: none;
            }
        }
    }

    #quoteSteady,
    #quoteTyped {
        padding: 16px;
        @media screen and (min-width: 960px) {
            margin: 0;
            padding: 40px;
        }
    }

    #quoteSteady {
        opacity: .3;
    }

    #quoteTyped {
        position: absolute;
        top: 0;
        left: 0;
    }

    .arrow--bottom:before {
        background: linear-gradient(135deg, transparent 0%, transparent 50%, $c-blue 50%, $c-blue 100%);
        color: transparent; // border color
        z-index: 2;

        // BORDER
        position: absolute;
        bottom: 1px;
        border-bottom: 3px solid $c-shadow-light;
        border-right: 3px solid $c-shadow-light;

        ////// FANCY BOX SHADOW - (NOTE: Looks broken on Mobile view)
        //filter:
        //    drop-shadow(0px 1px 0 $c-shadow)
        //    drop-shadow(0px 2px 0 $c-shadow)
        //    drop-shadow(0px 3px 0 $c-shadow)
        //    drop-shadow(0px 10px 10px rgba(0,0,0,0.2))
        //;
    }

    ////// AUTHOR
    .quote-author {
        font-style: italic;
        text-decoration: underline;
        text-underline-offset: .65em;
        text-decoration-color:rgba(0,0,0,.15);
        text-decoration-thickness: .5px;
    }
</style>
